import appConfig from "../appconfig";
import * as actions from "../store/mutation-types";
import mutationTypesBM100 from "../store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";
import routeMapper from "../router/routeMapper";

const _TIMEOUT_INTERVAL = 60000;
const _DIALOG_TIMER = 10;
const { timebox: timeBox } = appConfig.timeBoxImpl;

export default {
	data() {
		return {
			time: undefined,
			idleDialog: false,
			dialogTime: undefined,
			interval: undefined
		};
	},
	methods: {
		prepareEvents(callback) {
			const cb = () => e => {
				callback(e);
				if (e.type !== "scroll") {
					e.stopPropagation();
				}
			};
			const componentWrapper = document.getElementsByTagName("div")[0];
			componentWrapper.addEventListener("onload", cb("onload"), true);
			componentWrapper.addEventListener("mousemove", cb("mousemove"), true);
			componentWrapper.addEventListener("onmousedown", cb("onmousedown"), true);
			componentWrapper.addEventListener("onclick", cb("onclick"), true);
			componentWrapper.addEventListener("onkeypress", cb("onkeypress"), true);
			componentWrapper.addEventListener("ontouchmove", cb("ontouchmove"), true);
			componentWrapper.addEventListener("ontouchstart", cb("ontouchstart"), true);
			componentWrapper.addEventListener("ontouchend", cb("ontouchend"), true);
			componentWrapper.addEventListener("scroll", cb("onscroll"), true);
		},
		clearTimer(interval) {
			clearInterval(interval);
			this.dialogTime = undefined;
		},
		clearBasket() {
			this.clearTimer(this.interval);
			this.$store.dispatch(actions.CART_EMPTY_ALL).then(()=>{
				this.$store.commit(mutationTypesBM100.SET_SELECTED_MENU_POSITION, 0);
				this.goToHomePage();
			});
		},
		stayOnPage() {
			this.idleDialog = false;
			this.dialogTime = undefined;
			clearInterval(this.interval);
			this.prepareEvents(this.resetTimer);
			this.resetTimer();
		},
		inactive() {
			this.idleDialog = true;
			this.prepareEvents(() => {
				this.stayOnPage();
			});
			this.timeLeft();
			clearTimeout(this.time);
		},
		timeLeft() {
			const self = this;
			const initialCountDown = timeBox.realNow().add({seconds: _DIALOG_TIMER}).exec();
			if (self.interval) {
				clearInterval(self.interval);
			}
			self.interval = setInterval(function() {
				const diff = initialCountDown.diff(timeBox.realNow().exec());
				if (diff.as("milliseconds") <= 0 && self.idleDialog) {
					clearInterval(self.interval);
					self.clearBasket();
				} else if (!self.idleDialog) {
					clearInterval(self.interval);
					self.dialogTime = undefined;
					self.stayOnPage();
				} else {
					self.dialogTime = Math.ceil(diff.as("seconds"));
				}
			}, 0);
		},
		goToHomePage() {
			this.$router.push({ name: routeMapper.routeNames.Home || "Home" });
		},
		idleTimer() {
			this.prepareEvents(this.resetTimer);
		},
		resetTimer() {
			clearTimeout(this.time);
			this.idleDialog = false;
			this.time = setTimeout(this.inactive, _TIMEOUT_INTERVAL);
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.onResize);
			clearInterval(this.interval);
			clearTimeout(this.time);
		}
	}
};
